// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #66D2CE;
    --secondary: #2DAA9E;
    --light: #EAEAEA;
    --beige: #E3D2C3;
    --white: #FFFFFF;
    --black: #000000;
    --error: #EF4444;
}

.template-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); /* Flexible grid */
    gap: 15px;
    padding: 20px 0;
    max-width: 100%;
    overflow-x: auto; /* Allow horizontal scrolling if needed on small screens */
}

.template-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.template-item:hover {
    border-color: #2DAA9E;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.template-item.selected {
    border-color: #2DAA9E;
    background-color: #f0f8ff;
}

.template-preview {
    width: 100%;
    height: auto; /* Let the height adjust based on the image's aspect ratio */
    max-height: 150px; /* Set a max-height to keep it reasonable */
    object-fit: contain; /* Preserve the full image without cropping */
    border-radius: 4px;
}

.template-name {
    margin-top: 10px;
    font-size: 14px;
    text-align: center;
    color: #333;
}

/* Responsive adjustments */
@media (max-width: 600px) {
    .template-list {
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); /* Narrower on small screens */
    }

    .template-preview {
        max-height: 120px; /* Adjust max-height for smaller screens */
    }

    .template-name {
        font-size: 12px;
    }
}

@media (min-width: 1200px) {
    .template-list {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* Wider on large screens */
    }

    .template-preview {
        max-height: 200px; /* Larger max-height for bigger screens */
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/TemplateList.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D,EAAE,kBAAkB;IAChF,SAAS;IACT,eAAe;IACf,eAAe;IACf,gBAAgB,EAAE,0DAA0D;AAChF;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY,EAAE,4DAA4D;IAC1E,iBAAiB,EAAE,2CAA2C;IAC9D,mBAAmB,EAAE,6CAA6C;IAClE,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI;QACI,4DAA4D,EAAE,8BAA8B;IAChG;;IAEA;QACI,iBAAiB,EAAE,0CAA0C;IACjE;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,4DAA4D,EAAE,2BAA2B;IAC7F;;IAEA;QACI,iBAAiB,EAAE,yCAAyC;IAChE;AACJ","sourcesContent":[":root {\n    --primary: #66D2CE;\n    --secondary: #2DAA9E;\n    --light: #EAEAEA;\n    --beige: #E3D2C3;\n    --white: #FFFFFF;\n    --black: #000000;\n    --error: #EF4444;\n}\n\n.template-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); /* Flexible grid */\n    gap: 15px;\n    padding: 20px 0;\n    max-width: 100%;\n    overflow-x: auto; /* Allow horizontal scrolling if needed on small screens */\n}\n\n.template-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    border: 2px solid #e0e0e0;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n}\n\n.template-item:hover {\n    border-color: #2DAA9E;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.template-item.selected {\n    border-color: #2DAA9E;\n    background-color: #f0f8ff;\n}\n\n.template-preview {\n    width: 100%;\n    height: auto; /* Let the height adjust based on the image's aspect ratio */\n    max-height: 150px; /* Set a max-height to keep it reasonable */\n    object-fit: contain; /* Preserve the full image without cropping */\n    border-radius: 4px;\n}\n\n.template-name {\n    margin-top: 10px;\n    font-size: 14px;\n    text-align: center;\n    color: #333;\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n    .template-list {\n        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); /* Narrower on small screens */\n    }\n\n    .template-preview {\n        max-height: 120px; /* Adjust max-height for smaller screens */\n    }\n\n    .template-name {\n        font-size: 12px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .template-list {\n        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* Wider on large screens */\n    }\n\n    .template-preview {\n        max-height: 200px; /* Larger max-height for bigger screens */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
